@if (label) {
  <label class="ideals-label"
          [for]="id"
          [ngClass]="labelClassList">
    <span>
      {{label}}
      @if (isRequired) {
        <span> *</span>
      }

      @if (isOptional) {
        <span class="font-weight-normal"> {{'common.LABEL.optional' | translate}}</span>
      }
    </span>

    @if (labelSuffixTemplate) {
      <span class="ideals-label__suffix">
        <ng-container *ngTemplateOutlet="labelSuffixTemplate"></ng-container>
      </span>
    }
  </label>
}

<div class="ideals-input" [ngClass]="inputClassList">
  @if (showPrefix) {
    <label class="ideals-input-prefix"
            [for]="id"
            [ngClass]="prefixClass">
    </label>
  }

  <ng-content></ng-content>

  @if (showSuffix) {
    <label class="ideals-input-suffix"
            [for]="id"
            [ngClass]="suffixClass">
    </label>
  }
  @if (suffixTemplate) {
    <span class="ideals-input-suffix">
      <ng-container *ngTemplateOutlet="suffixTemplate"></ng-container>
    </span>
  }
</div>

@if (hasPasswordError) {
  <div class="security-strength"
        [ngClass]="passwordClassName"
        [@.disabled]="!errorTransitionEnabled"
        @transitionErrors>
    <span>{{passwordStates[passwordClassName] | translate}}</span>
  </div>
}

@for (error of errorList; track error) {
  @if (canShowError && !focused && error.text) {
    <div class="ideals-input-error"
          [@.disabled]="!errorTransitionEnabled"
          @transitionErrors>
      <div>{{error.text | async}}</div>
    </div>
  }
}
